<template>
  <div class="hzc-price-index">
    <TwoPageHeader :typeTitle="'焦化企业产能 > 正文'"></TwoPageHeader>
    <DetailTitle :title="'焦煤企业产能'"></DetailTitle>
    <div class="tabs">
      <div v-for="(item, index) in typeList" :key="index" :class="{'active':item.id===num}" @click="num = item.id">{{ item.title }}</div>
    </div>
    <div class="first" v-if="num === '1'">
      <EnterpriseCapacityDetailTabsOne></EnterpriseCapacityDetailTabsOne>
    </div>
    <div class="first" v-if="num === '2'">
      <EnterpriseCapacityDetailTabsTwo></EnterpriseCapacityDetailTabsTwo>
    </div>
    <div class="three" v-if="num === '3'">
      <EnterpriseCapacityDetailTabsThree></EnterpriseCapacityDetailTabsThree>
    </div>
  </div>
</template>

<script>
import TwoPageHeader from '@/components/common/twoPageHeader'
import DetailTitle from '@/components/common/detatilTitle'
import EnterpriseCapacityDetailTabsOne from '@/components/coke/detail/enterpriseCapacityDetailTabsOne'
import EnterpriseCapacityDetailTabsTwo from '@/components/coke/detail/enterpriseCapacityDetailTabsTwo'
import EnterpriseCapacityDetailTabsThree from '@/components/coke/detail/enterpriseCapacityDetailTabsThree'

export default {
  name: "priceIndex",
  components: {
    TwoPageHeader,
    DetailTitle,
    EnterpriseCapacityDetailTabsOne,
    EnterpriseCapacityDetailTabsTwo,
    EnterpriseCapacityDetailTabsThree
  },
  data() {
    return {
      typeList: [{title:'焦化产能一览',id:'1'}, {title:'焦化产能区域分布',id:'2'}, {title:'按炉型产能分布',id:'3'}],
      num:'1',
    }
  },
  created(){
        if (this.$route.query&&this.$route.query['flag']) {
            this.num = this.$route.query['flag'];
            console.log(this.$route.query['flag'])
    }
  }
}
</script>

<style scoped lang="less">
.active {
  background-color: #D3131A !important;
  color:#FFF;
  border:none !important;
}
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding:0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }
}
</style>
